import { useSyncExternalStore } from "react";
import {
  getCart, subscribeCart, cartCount, cartSubtotal,
  addToCart, setQty, removeFromCart, clearCart,
  type CartLine,
} from "./cart-store";

const EMPTY: CartLine[] = [];

export function useCart() {
  // getServerSnapshot returns a stable empty array so prerender/hydration match.
  const lines = useSyncExternalStore(subscribeCart, getCart, () => EMPTY);
  return {
    lines,
    count: cartCount(lines),
    subtotal: cartSubtotal(lines),
    add: addToCart,
    setQty,
    remove: removeFromCart,
    clear: clearCart,
  };
}
